import React, { useEffect } from 'react';

import './loading.site.scss';
import './loading.site.color.scss';

const LoadingSite: React.FC = () => {
  return (
    <div id="loading-site-image">
    <div id="loading-site-gradient">
      <div id="loading-site">
        <div className="loading-logo">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="50%" viewBox="0 0 1562 1301" enableBackground="new 0 0 1562 1301" preserveAspectRatio="xMidYMid meet">
            <path fill="#fff" opacity="1.000000" stroke="none" 
              d="
            M1147.583374,1.000000 
              C1148.994385,1.323490 1149.977417,1.889659 1150.984619,1.936162 
              C1339.082886,10.620954 1499.254883,139.047195 1548.554199,321.025543 
              C1557.458740,353.895203 1563.193481,387.287231 1562.060181,421.594849 
              C1561.439087,440.398224 1562.672363,459.337952 1560.923706,478.015289 
              C1555.022461,541.047546 1535.263062,599.797119 1502.847656,654.113037 
              C1458.486938,728.445190 1397.193970,784.540771 1319.346313,822.485596 
              C1318.334351,822.978882 1317.316895,823.460999 1316.713257,823.750854 
              C1156.811157,549.935669 997.052734,276.366577 837.692993,2.436791 
              C883.185120,2.050528 928.278564,2.013714 973.372070,2.002334 
              C1024.456665,1.989442 1075.541382,2.029421 1126.625854,1.955542 
              C1132.084351,1.947648 1137.541992,1.333115 1143.000000,1.000000 
              C1144.388916,1.000000 1145.777832,1.000000 1147.583374,1.000000 
            z"/>
            <path fill="#fff" opacity="1.000000" stroke="none" 
              d="
            M2.468667,1302.000000 
              C2.647123,1300.519287 3.157650,1298.959839 3.960730,1297.569214 
              C121.495354,1094.039185 239.057831,890.525146 356.542297,686.966125 
              C358.290497,683.937134 359.953735,682.407471 363.759155,682.411133 
              C484.898193,682.527893 606.037415,682.507080 727.176575,682.507080 
              C728.656738,682.507080 730.136963,682.507080 732.495422,682.507080 
              C613.109619,889.203491 494.097504,1095.252808 375.042725,1301.651123 
              C250.979111,1302.000000 126.958206,1302.000000 2.468667,1302.000000 
            z"/>
            <path fill="#fff" opacity="1.000000" stroke="none" 
              d="
            M1126.468628,1302.000000 
              C1113.114380,1279.519653 1100.289673,1257.004028 1087.333252,1234.564575 
              C982.114746,1052.332153 876.871460,870.114319 771.639526,687.889832 
              C770.749817,686.349060 769.913391,684.777649 768.657532,682.507080 
              C771.090881,682.507080 772.850769,682.507080 774.610596,682.507080 
              C895.248108,682.507080 1015.885681,682.517517 1136.523193,682.453369 
              C1139.913696,682.451538 1142.194458,682.925293 1144.150269,686.315796 
              C1262.087891,890.760803 1380.139893,1095.139771 1498.178589,1299.526611 
              C1498.510010,1300.100586 1498.803711,1300.696167 1499.057617,1301.640869 
              C1374.979126,1302.000000 1250.958130,1302.000000 1126.468628,1302.000000 
            z"/>
            <path fill="#fff" opacity="1.000000" stroke="none" 
              d="
            M454.999695,622.493164 
              C434.517212,622.493164 414.534760,622.493164 393.507324,622.493164 
              C511.921600,415.290649 629.954590,208.755310 748.281921,1.704882 
              C749.346191,3.355917 750.216675,4.602610 750.983276,5.910263 
              C812.950195,111.609657 874.885498,217.327591 936.968628,322.958710 
              C939.070923,326.535736 938.786255,328.984863 936.863525,332.328522 
              C882.254700,427.291748 827.711609,522.292847 773.280212,617.357727 
              C771.139038,621.097351 768.984253,622.624939 764.464172,622.617859 
              C661.476196,622.455872 558.487915,622.493103 454.999695,622.493164 
            z"/>
          </svg>
        </div>
        <div className="progress">
          <div className="progress-value"></div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default LoadingSite;